import React, { useState, useEffect } from "react";
import heroImage from "./images/bg-title-page-01.jpg";
import "./Menu.css";

import img1 from "./images/lunch-01.jpg";
import img2 from "./images/lunch-02.jpg";
import img3 from "./images/lunch-03.jpg";
import img4 from "./images/lunch-04.jpg";
import img5 from "./images/lunch-05.jpg";
import img6 from "./images/lunch-06.jpg";
import img7 from "./images/dinner-01.jpg";
import img8 from "./images/dinner-02.jpg";
import img9 from "./images/dinner-03.jpg";
import img10 from "./images/dinner-04.jpg";
import img11 from "./images/dinner-05.jpg";
import img12 from "./images/dinner-06.jpg";
import img13 from "./images/photo-gallery-14.jpg";
import img14 from "./images/photo-gallery-15.jpg";
import img15 from "./images/photo-gallery-16.jpg";

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState("all");
  const [cart, setCart] = useState([]);
  const [showCart, setShowCart] = useState(false);

  const breakfastImgs = [img1, img2, img3, img4, img5];
  const lunchImgs = [img6, img7, img8, img9, img10];
  const dinnerImgs = [img11, img12, img13, img14, img15];
  const allImgs = [...breakfastImgs, ...lunchImgs, ...dinnerImgs];

  const getImages = () => {
    switch (activeCategory) {
      case "breakfast":
        return breakfastImgs;
      case "lunch":
        return lunchImgs;
      case "dinner":
        return dinnerImgs;
      default:
        return allImgs;
    }
  };

  const addToCart = (img) => {
    const randomPrice = (Math.random() * (20 - 5) + 5).toFixed(2);
    const newItem = { img, price: parseFloat(randomPrice) };
    setCart([...cart, newItem]);
    setShowCart(true);
  };

  const removeFromCart = (index) => {
    setCart(cart.filter((_, i) => i !== index));
  };

  const totalPrice = cart.reduce((total, item) => total + item.price, 0).toFixed(2);

  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") setShowCart(false);
    };
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div className="menu-page">
      <section
        className="hero"
        style={{ backgroundImage: `url(${heroImage})` }}
      >
        <div className="hero-content">
          <h1>Plato Menu</h1>
        </div>
      </section>

      <div className="scrolling-gallery-wrapper">
        <div className="scrolling-gallery">
          {allImgs.map((img, index) => (
            <div className="gallery-item" key={index}>
              <img src={img} alt={`Menu ${index}`} />
            </div>
          ))}
        </div>
      </div>

      <div className="Full-menu">
        <div className="Menu-btns">
          <button
            className={`btn-menu ${activeCategory === "all" ? "active" : ""}`}
            onClick={() => setActiveCategory("all")}
          >
            All
          </button>
          <button
            className={`btn-menu ${activeCategory === "breakfast" ? "active" : ""}`}
            onClick={() => setActiveCategory("breakfast")}
          >
            Breakfast
          </button>
          <button
            className={`btn-menu ${activeCategory === "lunch" ? "active" : ""}`}
            onClick={() => setActiveCategory("lunch")}
          >
            Lunch
          </button>
          <button
            className={`btn-menu ${activeCategory === "dinner" ? "active" : ""}`}
            onClick={() => setActiveCategory("dinner")}
          >
            Dinner
          </button>
        </div>

        <div className="All">
          {getImages().map((img, index) => (
            <div key={index} className="menu-item">
              <img src={img} alt={`Menu ${index}`} />
              <button
                className="add-cart-btn"
                onClick={() => addToCart(img)}
              >
                Add to Cart
              </button>
            </div>
          ))}
        </div>
      </div>

      {showCart && (
        <div className="cart-popup">
          <h2>Your Cart ({cart.length})</h2>
          {cart.length === 0 ? (
            <p>Your cart is empty</p>
          ) : (
            <>
              {cart.map((item, index) => (
                <div key={index} className="cart-item">
                  <img src={item.img} alt={`Cart ${index}`} />
                  <p>${item.price.toFixed(2)}</p>
                  <button onClick={() => removeFromCart(index)}>Remove</button>
                </div>
              ))}
              <h3>Total: ${totalPrice}</h3>
              <button className="checkout-btn">Checkout</button>
              <button
                className="checkout-btn"
                style={{ backgroundColor: "grey", marginTop: "10px" }}
                onClick={() => setShowCart(false)}
              >
                Close
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default Menu;
